import { render, staticRenderFns } from "./mastercollector.vue?vue&type=template&id=db9644f6&"
import script from "./mastercollector.vue?vue&type=script&lang=js&"
export * from "./mastercollector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports